/**
 * Validates Spotify artist ID format
 * @param {string} id - The artist ID to validate
 * @returns {boolean} - True if the ID is valid, false otherwise
 */
export const isValidArtistId = (id) => {
  const SPOTIFY_ARTIST_ID_LENGTH = 22;

  return typeof id === 'string' && id.length === SPOTIFY_ARTIST_ID_LENGTH && /^[A-Za-z0-9]+$/.test(id);
};

/**
 * Builds Spotify embed URL for an artist
 * @param {string} artistId - The Spotify artist ID
 * @returns {string|null} - The embed URL or null if artist ID is invalid
 */
export const buildEmbedUrl = (artistId) => {
  if (!isValidArtistId(artistId)) {
    return null;
  }

  const baseUrl = 'https://open.spotify.com/embed/artist';
  const params = new URLSearchParams({
    theme: '1',
  });

  return `${baseUrl}/${artistId}?${params.toString()}`;
};
